export default "__VITE_ASSET__CZuR4Tz8__"